import React from 'react';
import styled from 'styled-components';

interface IPlayButton {
  playing: boolean;
  onClick: () => void;
}

export const PlayButton: React.FC<IPlayButton> = ({ playing, onClick }) => {
  if (!playing) {
    return (
      <StyledIcon onClick={onClick}>
        <svg
          width="30"
          height="30"
          viewBox="0 0 96 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="48" cy="48" r="45.5" stroke="white" strokeWidth="5" />
          <path
            d="M69.5 45.4019C71.5 46.5566 71.5 49.4434 69.5 50.5981L39.5 67.9186C37.5 69.0733 35 67.6299 35 65.3205L35 30.6795C35 28.3701 37.5 26.9267 39.5 28.0814L69.5 45.4019Z"
            fill="white"
          />
        </svg>
      </StyledIcon>
    );
  } else {
    return (
      <StyledIcon onClick={onClick}>
        <svg
          width="30"
          height="30"
          viewBox="0 0 96 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="48" cy="48" r="45.5" stroke="white" strokeWidth="5" />
          <rect x="37" y="27" width="7" height="42" rx="3.5" fill="white" />
          <rect x="51" y="27" width="7" height="42" rx="3.5" fill="white" />
        </svg>
      </StyledIcon>
    );
  }
};

const StyledIcon = styled.div`
  width: 30px;
  height: 30px;

  &:hover {
    cursor: pointer;
  }
`;
